module.exports = __webpack_public_path__ + "img/beneficio-pension.ae1b696b.svg";